// Siparişten faturaya devirde stok bilgisi: sipariş "stok işlensin" ile kaydedildiyse
// stok hareketi sipariş aşamasında yazılmıştır. Fatura kaydedilince backend sipariş hareketini
// geri alır ve faturanın hareketini yazar (çift stok olmaz). Ön yüz yalnız bilgi notu gösterir.

export const ORDER_STOCK_HANDOVER_MESSAGE =
  'Stok sipariş aşamasında işlendi; fatura kaydedilince sipariş hareketi faturaya devredilir.';

export interface OrderStockHandoverInfo {
  processStock: boolean;
  stockProcessedAt: string | null;
}

/** Sipariş API yanıtından (camelCase ya da PascalCase) devir bilgisini çıkarır. */
export const pickOrderStockHandover = (orderData: any): OrderStockHandoverInfo => {
  const processStock = Boolean(orderData?.processStock ?? orderData?.ProcessStock ?? false);
  const rawAt = orderData?.stockProcessedAt ?? orderData?.StockProcessedAt ?? null;
  const stockProcessedAt = rawAt ? String(rawAt) : null;
  return { processStock, stockProcessedAt };
};

/** Faturaya taşınan sipariş verisinde stok sipariş aşamasında işlendi mi? */
export const isOrderStockProcessed = (payload: Partial<OrderStockHandoverInfo> | null | undefined): boolean =>
  Boolean(payload?.stockProcessedAt);
